<template>
    <div>
        <div class="mb-5 p-5 bg-white rounded">
            <div class="d-lg-flex align-items-center justify-content-between mb-4 gap-2" style="position: relative;">
                <div class="justify-content-start d-flex">
                    <h3><strong style="color:#1A0054">Reporte de Usuarios</strong></h3>
                </div>
                <div class="justify-content-center d-lg-flex d-md-flex d-sm-grid" style="position: relative;">
                    <select @change="changeFiltroPeriodo()" name="order-filter" id="order-filter"
                        class="form-control col-sm-12 col-md-6 col-lg-auto sin-borde text-primary bg-utel-v2-secondary mx-1 py-2 my-2 rounded-8"
                        v-model="filtroPeriodo">
                        <option value="week">Última semana</option>
                        <option value="month" selected>Últimos 30 días</option>
                    </select>
                    <select v-if="issuperadmin == 'true'" @change="changeFiltroEmpresa()" name="order-filter"
                        id="order-filter" v-model="filtroEmpresa"
                        class="form-control col-sm-12 col-md-6 col-lg-auto sin-borde text-primary bg-utel-v2-secondary mx-1 py-2 my-2 rounded-8">
                        <option value="all" selected>Todas las empresas</option>
                        <option v-for="r of dessertsCompany" :key="r.id" :value="r.id">{{ r.name }}</option>
                    </select>
                    <a :href="download"
                        class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2">Descargar
                        reporte</a>
                    <div class="tutorial-container" v-if="showTutorial && !showParentTutorial && !isOpenTutorial">
                        <div class="tutorial-content">
                            <div class="card tutorial-card">
                                <div class="card-header text-end ">
                                    <div class="card-arrow d-none d-sm-block"></div>
                                    <div class="d-flex justify-content-end">
                                        <button class="btn btn-link text-white" @click="markTutorialAsShowed()"><i
                                                class="fa fa-xmark"></i></button>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <h3 class="text-white">¿Cómo descargar mis reportes de usabilidad?</h3>
                                    <span>Accede a insights clave. Dirígete al menú lateral y elige entre 'Usuarios' y 'Aprendizaje', dependiendo del reporte que deseas descargar. Haz clic en 'Descargar reporte'. ¡Analiza datos y mejora estrategias para potenciar tu negocio con Utel X for Business!</span>
                                </div>
                                <div class="card-footer d-flex justify-content-end pb-3 pe-5 pt-2">
                                    <a href="#" @click="markTutorialAsShowed(true)" class="text-end text-white">
                                        Ver tutorial
                                        <i class="fa ms-2 fa-arrow-right text-white"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="py-4">
                <div class="row">
                    <div class="col-12">
                        <use-platform-graphic-component v-if="filtroPeriodo == 'month'" :datacursos="dataCursos"
                            :urlstudentsdetail="urlstudentsdetail"
                            :go_to_learning="go_to_learning"></use-platform-graphic-component>
                        <use-platform-week-graphic-component v-if="filtroPeriodo == 'week'" :datacursos="dataCursos"
                            :urlstudentsdetail="urlstudentsdetail"
                            :go_to_learning="go_to_learning"></use-platform-week-graphic-component>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <active-users-graphic-component v-if="filtroPeriodo == 'month'"
                            :graphicoestudiantes="GraficoEstudiantes" :urlstudentsdetail="urlstudentsdetail"
                            :go_to_users="go_to_users"></active-users-graphic-component>
                        <active-users-week-graphic-component v-if="filtroPeriodo == 'week'"
                            :graphicoestudiantes="GraficoEstudiantes" :urlstudentsdetail="urlstudentsdetail"
                            :go_to_users="go_to_users"></active-users-week-graphic-component>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                        <approved-routes-graphic-component :datarutas="PorcentajeRoutes"
                            :urlstudentsdetail="urlstudentsdetail"
                            :go_to_learning="go_to_learning"></approved-routes-graphic-component>
                    </div>
                    <!--<div class="col-sm-12 col-md-6 col-lg-6">
                        <ranking-by-courses-graphic-component
                        :dataranking="dataRanking"
                        :urlstudentsdetail="urlstudentsdetail">
                        </ranking-by-courses-graphic-component>
                    </div>-->
                </div>
            </div>
        </div>
        <modalVideo
            url="https://www.youtube.com/embed/o4nLLS_eYaM?si=bCHfgdcoEHCYV7Tx"
            v-if="openVideoModal"
            @onClose="openVideoModal = false"
        ></modalVideo>
    </div>
</template>

<script>
import modalVideo from '../tutorials/ModalTutorial.vue';

export default {
    props: [
        "issuperadmin",
        "get",
        "headersTabsCompany",
        "urldatacompany",
        "urldataclient",
        "urldataarea",
        "datagraphics",
        "urlstudentsdetail",
        "urltotalcourses",
        "urlplanesgrafica",
        "urltotalroutes",
        "urltotalplanes",
        "urltotalclients",
        "urldataplanes",
        "urldatacourses",
        "urldataroutes",
        "urldatastudents",
        "urlroutesbytime",
        "urlrankingbycourses",
        "allareas",
        "download",
        "go_to_learning",
        "go_to_users",
        "showParentTutorial",
        "isOpenTutorial"
    ],
    components: {
        modalVideo
    },
    data: function () {
        return {
            dessertsCompany: [],
            GraficoEstudiantes: [],
            dataCursos: [],
            PorcentajeRoutes: [],
            dataRanking: [],
            filtroEmpresa: "all",
            filtroPeriodo: "month",
            showTutorial: false,
            openVideoModal: false
        }
    },
    mounted() {
        this.getDataCompany();
        this.studentsDashboard();
        this.coursesDashboard();
        this.routesDashboard();
        this.rankingByCoursesDashboard();
        this.checkTutorialsShowed();
    },
    methods: {
        getDataCompany() {
            axios.get(`${this.urldataclient}?withUsers=true`)
                .then((resCompany) => {
                    if (resCompany == null) return;
                    this.dessertsCompany = resCompany.data[0]['clients'];
                });
        },
        studentsDashboard(type = 'tiempo') {
            const period = this.filtroPeriodo;
            const bsns = this.filtroEmpresa;
            let params = '?'
            if (period) {
                if (period) params += `&query=${period}`;
            }
            if (bsns) {
                if (bsns != 'all') params += `&filterClient=${bsns}`
            }
            if (type) params += `&typeQuery=${type}`;
            axios.get(`${this.urldatastudents}${params}`).then((resGraphics) => {
                this.GraficoEstudiantes = resGraphics.data[0].studentsCount;
            });
        },
        coursesDashboard() {
            axios.get(`${this.urlroutesbytime}?withUsers=true&queryPeriod=${this.filtroPeriodo}`)
                //axios.get(`${this.urlplanesgrafica}?withUsers=true`)
                .then((resPlanesGraphics) => {
                    const dataFinal = resPlanesGraphics.data;
                    let data = [];
                    dataFinal.forEach(function (e) {
                        data.push(e.totalCursos);
                    });
                    this.dataCursos = data;
                });
        },
        routesDashboard() {
            axios.get(`${this.urldataroutes}?withUsers=true`)
                .then((resGraphics) => {
                    this.PorcentajeRoutes = resGraphics.data.routes;
                });
        },
        rankingByCoursesDashboard() {
            axios.get(`${this.urlrankingbycourses}?withUsers=true&queryClient=${this.filtroEmpresa}`)
                .then((response) => {
                    const dataFinal = response.data;
                    this.dataRanking = dataFinal;
                });
        },
        checkEvent(event, typeValue) {
            const value = event.target.value;
            axios.get(`${this.datagraphics}?withUsers=true&query=${value}&typeQuery=${typeValue}`)
                .then((resGraphics) => {
                    this.GraficoEstudiantes = resGraphics.data[3].studentsCount;
                });
        },
        filtrarEstudiantePorCliente(val) {
            const value = val.target.value;
            axios.get(`${this.urldatastudents}?withUsers=true&filterClient=${value}`)
                .then((resGraphics) => {
                    this.GraficoEstudiantes = resGraphics.data[0].studentsCount;
                });
        },
        filtrarPorCliente() {
            axios
                .get(`${this.urlroutesbytime}?withUsers=true&queryPeriod=${this.filtroPeriodo}&queryClient=${this.filtroEmpresa}`)
                //.get(`${this.urlplanesgrafica}?withUsers=true&typeQuery=cliente&query=${this.filtroEmpresa}`)
                .then((resGraphics) => {
                    const dataFinal = resGraphics.data;
                    let data = [];
                    dataFinal.forEach(function (e) {
                        data.push(e.totalCursos);
                    });
                    this.dataCursos = data;
                });
        },
        selectCompanyXRoute() {
            const value = this.filtroEmpresa;
            axios.get(`${this.urldataroutes}?withUsers=true&queryClient=${value}`)
                .then((resGraphics) => {
                    this.PorcentajeRoutes = resGraphics.data.routes;
                });
        },
        changeFiltroEmpresa() {
            this.studentsDashboard();
            this.filtrarPorCliente();
            this.selectCompanyXRoute();
        },
        changeFiltroPeriodo() {
            this.studentsDashboard();
            this.filtrarPorCliente();
        },
        checkTutorialsShowed(){
            const tutorials = localStorage.getItem('showedtutorials') || null;
            if ( tutorials ) {
                const tutorialsArray = JSON.parse( tutorials );
                if (!tutorialsArray.includes('dashboard-downloadreports')) {
                    this.showTutorial = true;
                }
            }else{
                this.showTutorial = true;
            }
        },
        markTutorialAsShowed(openVideo = false){
            const tutorials = localStorage.getItem('showedtutorials') || null;
            if ( tutorials ) {
                const currentTutorialsShowed = JSON.parse( tutorials );
                localStorage.setItem('showedtutorials', JSON.stringify([...currentTutorialsShowed, 'dashboard-downloadreports']));
            }else{
                localStorage.setItem('showedtutorials',JSON.stringify(['dashboard-downloadreports']));
            }

            this.showTutorial = false;

            if ( openVideo ) {
                this.openVideoModal = true;
            }
        }
    }
}
</script>

<style>
    .tutorial-card{
        background-color: #4000BC;
        color: #fff;
    }

    .tutorial-card .card-header{
        border-bottom: none;
        background-color: inherit !important;
    }

    .tutorial-card .card-footer{
        border-top: none;
        background-color: inherit !important;
    }

    .tutorial-container{
        position: absolute;
    }

    .tutorial-container .tutorial-content{
        transform: translate(10px, 70%);
    }

    .card-arrow{
        position: absolute;
        width: 40px;
        height: 40px;
        margin-top: -25px;
        background-color: #4000BC;
        transform: rotate(45deg);
        right: 40px;
    }


</style>
